module.exports = __webpack_public_path__ + "favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/favicon-16x16.png
// module id = 370
// module chunks = 0